import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import UserNew from "../components/UserNew";
import { registerUser, getManagementCompanyInfo } from "../actions/usernew";

const mapStateToProps = (state) => {
  const { userNew } = state;
  console.log("userNew:", userNew);

  return {
    companyinfo: userNew.companyinfo,
    loading: true,
    error: userNew.error
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      registerUser,
      getManagementCompanyInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UserNew);